import * as React from 'react';

import * as styles from './CarouselLayout.css';

interface ICarouselLayoutProps {
  src: string;
}

export const CarouselLayout = React.memo(({ src }: ICarouselLayoutProps) => {
  return (
    <div className={styles['container']}>
      <img className="lazyload" data-src={src} />
    </div>
  );
});

CarouselLayout.displayName = 'CarouselLayout';
